import Vue from 'vue'
import {mapGetters, mapMutations} from 'vuex'

export default {
    computed: {
        ...mapGetters({
            can: 'Auth/can',
            user: 'Auth/user',

        }),





    },
    data() {
        return {
            polls: []
        }
    },
    methods: {
        ...mapMutations({
            setPageTitle: 'UI/viewTitle',
            setBackAction: 'UI/backAction',
            showLoading: 'UI/showLoading',
            loadingProgress: 'UI/loadingProgress',
            showLoadingLight: 'UI/showLoadingLight',
            showModal: 'UI/showModal',
            closeModal: 'UI/closeModal',
            setModalParams: 'UI/setModalParams',
            addMessage: 'Messages/addMessage',
            addSuccess: 'Messages/addSuccess',
            addError: 'Messages/addError',
            addInfo: 'Messages/addInfo',
            addWarning: 'Messages/addWarning',
            clearMessages: 'Messages/clearMessages',

        }),

        poll(name, method, delay) {
            Vue.set(this.polls, name, null)
            this.polls[name] = setInterval(() => {
                this[method]()
            }, delay)
            this[method]()
        },

        stopPoll(name) {
            clearInterval(this.polls[name])
        }

    }
}


// WEBPACK FOOTER //
// ./src/mixins/global.js